var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('strong',[_vm._v(_vm._s(_vm.note.user.name)+", "+_vm._s(_vm.note.date))]),_vm._v(" "),(_vm.note.can_edit)?_c('note-actions',{on:{"edit":_vm.onEdit,"delete":_vm.onDelete}}):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.note.parsed_body)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }